import dashboard from '@/navigation/vertical/Ptc/dashboard';
import { getDashboardNav } from './dashboards/dashboards';
import { getCrmNav } from './crm/crm';
import relatoriosRouter from './relatorios/relatorios.router';
import cadastrosRouter from './cadastros/cadastro.router';
import clienteDkpRouter from './cliente-dkp/cliente-dkp.router';
import sistemaRouter from './sistema/sistema.router';
import publicasRouter from './publicas';
import operacao from './operacao/operacoes';
import { getPedidosNav } from './pedidos/pedidos';
import devolucoes from './devolucoes';
import budget from './budget/budget';
import budgetLider from './budgetLider/budgetLider';

export function buildNavMenuItems() {
  return [
    ...getDashboardNav(),
    ...getCrmNav(),
    { title: 'Assistência Técnica', route: 'assistencia-tecnica', icon: 'ToolIcon', action: 'read', resource: 'AssistenciaTecnica', explicitModule: true, activeAdminDkpOnly: true },
    ...publicasRouter,
    ...clienteDkpRouter,
    ...sistemaRouter,
    ...getPedidosNav(),
    ...operacao,
    ...devolucoes,
    ...budget,
    ...budgetLider,
    ...relatoriosRouter,
    ...cadastrosRouter,
    ...dashboard,
  ];
}

export default buildNavMenuItems();
